import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 课程下拉列表
  messageCourseList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/message/courseList?${parameterChange(data)}`,
      method: 'get',
      data,
    });
  },
  // 消息列表
  messageList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/message/messageList?${parameterChange(data)}`,
      method: 'get',
      data,
    });
  },
  // 消息详情
  messageDetail(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/message/messageDetail?${parameterChange(data)}`,
      method: 'get',
      data,
    });
  },
  // 消息新增
  messageAdd(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/message/messageAdd`,
      method: 'post',
      data,
    });
  },
  // 课程删除
  messageDelete(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/message/messageDelete`,
      method: 'post',
      data,
    });
  },
  // 课程删除
  courseInfo(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/message/courseInfo?${parameterChange(data)}`,
      method: 'get',
      data,
    });
  },
};
